export default __webpack_public_path__ + "static/media/about_us_shirly.349a9275.png";